import { z } from "zod";
import { DbCreateInputOmit, DbUpdate } from "../../helpers";
import { OmitStrict } from "../../utils";
import { DataSourceRemoteType } from "./data-source";
import { Entity } from "../../common";

export const ImportJobState = z.enum(["PendingInput", "Queued", "InProgress", "Failed", "Success"]);
export const ImportJobOperation = z.enum(["Check", "Import"]);

export const ImportJob = Entity.extend({
  designSystemId: z.string(),
  designSystemVersionId: z.string(),
  sourceIds: z.array(z.string()),
  state: ImportJobState,
  createdByUserId: z.string().optional(),
  importContextId: z.string(),
  error: z.string().optional(),
  sourceType: DataSourceRemoteType,
  importContextCleanedUp: z.boolean(),
});

export type ImportJobState = z.infer<typeof ImportJobState>;
export type ImportJobOperation = z.infer<typeof ImportJobOperation>;
export type ImportJob = z.infer<typeof ImportJob>;

export type CreateImportJob = DbCreateInputOmit<ImportJob>;
export type UpdateImportJob = OmitStrict<
  DbUpdate<ImportJob>,
  "designSystemId" | "createdByUserId" | "sourceIds" | "importContextId"
>;
